import { BaseballEventStatusId } from '@collector/sportsapi-client-legacy'

export const inningEventStatuses: BaseballEventStatusId[] = [
  BaseballEventStatusId.FirstInning,
  BaseballEventStatusId.SecondInning,
  BaseballEventStatusId.ThirdInning,
  BaseballEventStatusId.FourthInning,
  BaseballEventStatusId.FifthInning,
  BaseballEventStatusId.SixthInning,
  BaseballEventStatusId.SeventhInning,
  BaseballEventStatusId.EighthInning,
  BaseballEventStatusId.NinthInning,
  BaseballEventStatusId.TenthInning,
  BaseballEventStatusId.EleventhInning,
  BaseballEventStatusId.TwelfthInning,
  BaseballEventStatusId.ThirteenthInning,
  BaseballEventStatusId.FourteenthInning,
  BaseballEventStatusId.FifteenthInning,
  BaseballEventStatusId.SixteenthInning,
  BaseballEventStatusId.SeventeenthInning,
  BaseballEventStatusId.EighteenthInning,
  BaseballEventStatusId.NineteenthInning,
  BaseballEventStatusId.TwentiethInning,
  BaseballEventStatusId.TwentyFirstInning,
  BaseballEventStatusId.TwentySecondInning,
  BaseballEventStatusId.TwentyThirdInning,
]
